/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const checkoutScheduledReplenishment = {
  checkoutScheduledReplenishment: {
    autoReplenishOrder: 'Ordem de reabastecimento automática',
    orderType_PLACE_ORDER: 'Nenhuma (pedido único)',
    orderType_SCHEDULE_REPLENISHMENT_ORDER: 'Ordem de reabastecimento',
    every: 'Cada',
    recurrencePeriodType_DAILY: 'Dia(s)',
    recurrencePeriodType_WEEKLY: 'Semana(s)',
    recurrencePeriodType_MONTHLY: 'Mês',
    dayOfMonth: 'Dia do mês',
    dayOfMes: 'Durante o dia',
    startOn: 'Começar em',
    repeatOnDays: 'Repita nos dias seguintes',
    daysOfWeek: {
      MONDAY: 'Segunda-feira',
      TUESDAY: 'Terça-feira',
      WEDNESDAY: 'Quarta-feira',
      THURSDAY: 'Quinta-feira',
      FRIDAY: 'Sexta-feira',
      SATURDAY: 'Sábado',
      SUNDAY: 'Domingo',
    }
  },
};
